import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // slide  : 각 슬라이드 엘리먼트
  // thumb  : 썸네일 이미지 (선택)
  // dot    : 인디케이터 도트
  // counter: "현재 / 전체" 카운터 텍스트 엘리먼트 (선택 — 새로 추가)
  static targets = ["slide", "thumb", "dot", "counter"]
  static values = { index: Number }

  connect() {
    this.showSlide(this.indexValue)
    this._touchStartX = 0
    this._onTouchStart = this.handleTouchStart.bind(this)
    this._onTouchEnd = this.handleTouchEnd.bind(this)
    this.element.addEventListener("touchstart", this._onTouchStart, { passive: true })
    this.element.addEventListener("touchend", this._onTouchEnd, { passive: true })
  }

  disconnect() {
    this.element.removeEventListener("touchstart", this._onTouchStart)
    this.element.removeEventListener("touchend", this._onTouchEnd)
  }

  handleTouchStart(e) {
    this._touchStartX = e.touches[0].clientX
  }

  handleTouchEnd(e) {
    const dx = e.changedTouches[0].clientX - this._touchStartX
    if (Math.abs(dx) > 40) {
      dx < 0 ? this.next() : this.prev()
    }
  }

  next() {
    const total = this.slideTargets.length
    if (total <= 1) return
    this.showSlide((this.indexValue + 1) % total)
  }

  prev() {
    const total = this.slideTargets.length
    if (total <= 1) return
    this.showSlide((this.indexValue - 1 + total) % total)
  }

  goTo(event) {
    const idx = parseInt(event.params.slide, 10)
    this.showSlide(idx)
  }

  showSlide(idx) {
    this.slideTargets.forEach((slide, i) => {
      slide.style.opacity = i === idx ? "1" : "0"
    })
    this.thumbTargets.forEach((thumb, i) => {
      if (i === idx) {
        thumb.classList.add("border-neon-green/60", "ring-1", "ring-neon-green/30")
        thumb.classList.remove("border-dark-border")
      } else {
        thumb.classList.remove("border-neon-green/60", "ring-1", "ring-neon-green/30")
        thumb.classList.add("border-dark-border")
      }
    })
    this.dotTargets.forEach((dot, i) => {
      if (i === idx) {
        dot.style.background = "#39FF14"
        dot.style.width = "18px"
        dot.style.opacity = "1"
        dot.style.boxShadow = "0 0 6px rgba(57,255,20,0.6)"
      } else {
        dot.style.background = "rgba(57,255,20,0.25)"
        dot.style.width = "6px"
        dot.style.opacity = "0.6"
        dot.style.boxShadow = "none"
      }
    })
    // counter 타겟이 존재할 경우 "현재 / 전체" 형식으로 업데이트
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${idx + 1} / ${this.slideTargets.length}`
    }
    this.indexValue = idx
  }
}
